import { Outlet } from "react-router";
import { useAuth } from "../providers/AuthenticationProvider";

const OnlyAdmin = () => {
	const { user, profile } = useAuth();
	if (
		user != null &&
		user.uid != "" &&
		profile != null &&
		profile.role === "Admin"
	) {
		return <Outlet />;
	}
	return (
		<>
			<h1>Unauthorized</h1>
		</>
	);
};

export default OnlyAdmin;
